import { type IBuyerUserQuery } from 'application/querySchemas/IBuyerUserQuery';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerCheckTokenClient } from 'interfaceAdapter/gatewaySchemas/IBuyerCheckTokenClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class BuyerUserQuery implements IBuyerUserQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly token: IBuyerUserTokenRepository,
        @inject('IBuyerCheckTokenClient')
        public readonly checkTokenClient: IBuyerCheckTokenClient,
    ) {}

    public checkToken = async (incrementLoginCount: boolean): Promise<any> => {
        const token = this.token.get();
        if (!token) {
            return {
                user: null,
                status: false,
            };
        }
        const { data, status } = await this.checkTokenClient.get({
            token,
            addLoginCount: incrementLoginCount,
        });
        return {
            user: data,
            status: status === 'valid',
        };
    };
}
